import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {DownloadService} from "../../common/services/downloadService";
import {ListOfShipmentsFilters, ListOfShipmentsModel, ListOfShipmentsSummaryModel} from "../models/listOfShipments";

export class ListOfShipmentsService {
    private static baseUrl = apiUrls.reports.listOfShipments;

    public static async generateReport(filters: ListOfShipmentsFilters): Promise<AxiosResponse<PageableModel<ListOfShipmentsModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<ListOfShipmentsModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: ListOfShipmentsFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    public static async generateSummaryReport(filters: ListOfShipmentsFilters): Promise<AxiosResponse<PageableModel<ListOfShipmentsSummaryModel>>> {
        const url = `${Api.getUrl(this.baseUrl)}/summary`;

        return await http.get<PageableModel<ListOfShipmentsSummaryModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async downloadSummaryReport(filters: ListOfShipmentsFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.downloadSummaryReport(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: ListOfShipmentsFilters) {
        return `arrivalFerryFrom=${filters.arrivalFerryFrom}&arrivalFerryTo=${filters.arrivalFerryTo}` +
            `&departureFerryFrom=${filters.departureFerryFrom}&departureFerryTo=${filters.departureFerryTo}` +
            `&relationType=${filters.relationType}&cargoType=${filters.cargoType}&orderStatus=${filters.orderStatus}` +
            `&shipownerEntityId=${filters.shipownerEntityId}&ferryEntityId=${filters.ferryEntityId}`;
    }
}
